
import LeaveList from './LeaveList';
import QuickApplyLeave from './QuickApplyLeave';
import icon from "./../../../assets/images/user/quick_apply.png"

// const UserApplyLeave = () => {
//   return (
//     <section className=' flex flex-wrap lg:flex-nowrap w-full'>
//       <QuickApplyLeave />
//       <LeaveList />
//     </section>
//   );
// }

// export default UserApplyLeave;




const UserApplyLeave = () => {
  return (
    <section className='flex flex-col lg:flex-row w-full'>
      <div className=" flex items-center lg:hidden">
        <img src={icon} alt="attendance-icon" />
        <p className="text-[#D23B7D] text-[16px] pb-[7px]">Quick Apply</p>
      </div>
      <div className="order-2 lg:order-1 w-full lg:w-[60%] lg:border-r border-[#E9E9E9] quick-apply">
        <QuickApplyLeave />
      </div>
      <div className="order-1 lg:order-2 leaveList-container w-full lg:w-[40%] overflow-auto scrollbar">
        <LeaveList />
      </div>
    </section>
  );
}

export default UserApplyLeave;
